import { Middleware, isRejectedWithValue } from '@reduxjs/toolkit';
import { SnackType } from '@/features/snacks/enums/SnackType';
import { RootPaths } from '@/routes/paths';
import { router } from '@/routes/router';
import SnackService from '@/services/SnackService/SnackService';

type ApiErrorAction = {
  payload: {
    data: ApiError;
  };
};

type ApiError = {
  name: string;
  message: string;
};

export const isApiError = (action: unknown): action is ApiErrorAction => {
  const typedAction = action as ApiErrorAction;

  try {
    return isRejectedWithValue(action) && 'name' in typedAction.payload.data && 'message' in typedAction.payload.data;
  } catch (e) {
    return false;
  }
};

export const apiErrorHandler: Middleware = (_api) => (next) => (action) => {
  if (isApiError(action)) {
    SnackService.add({
      type: SnackType.Error,
      title: action.payload.data.name,
      content: action.payload.data.message,
    });
  }

  return next(action);
};

export const unauthorizedErrorHandler: Middleware = () => (next) => (action) => {
  // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these matchers!
  const isUnauthorizedError = isRejectedWithValue(action) && 'status' in action.error && action.error?.status === '401';

  if (isUnauthorizedError) {
    router.navigate(RootPaths.SIGN_IN);
  }

  return next(action);
};
